import styled from "styled-components";

export const LoadingWrapper = styled.div`
  font-size: 0.8125rem;
  color: #424242;
  letter-spacing: 2px !important;
  padding: 0 1px;
`;
